import {Component, Input, OnChanges} from '@angular/core';
import {DeviceParamGatewayV3Server} from "../../../../../../shared/classes/device/type-gateway-v3/device-param-gateway-v3-server";
import {FormControl, FormGroup} from "@angular/forms";

@Component({
    selector: 'app-param-server',
    templateUrl: './param-server.component.html',
    styleUrls: ['./param-server.component.css']
})
export class ParamServerComponent implements OnChanges {

    serverForm: FormGroup;
    @Input('deviceParamGatewayV3Server') deviceParamGatewayV3Server: DeviceParamGatewayV3Server = new DeviceParamGatewayV3Server();
    @Input('editable') editable: boolean = true;

    constructor() {
    }

    ngOnChanges() {
        if (!this.deviceParamGatewayV3Server) return;
        if (this.serverForm) return;
        this.serverForm = new FormGroup({
            use_ssl: new FormControl(this.deviceParamGatewayV3Server.use_ssl),
            gw_firmware_url: new FormControl(this.deviceParamGatewayV3Server.gw_firmware.url),
            gw_firmware_version: new FormControl(this.deviceParamGatewayV3Server.gw_firmware.version),
            liris_firmware_url: new FormControl(this.deviceParamGatewayV3Server.liris_firmware.url),
            liris_firmware_version: new FormControl(this.deviceParamGatewayV3Server.liris_firmware.version),
            config: new FormControl(this.deviceParamGatewayV3Server.config),
            data: new FormControl(this.deviceParamGatewayV3Server.data)
        });
        this.setDeviceWithForm();
    }

    setDeviceWithForm() {
        this.deviceParamGatewayV3Server.use_ssl = this.serverForm.value.use_ssl;
        this.deviceParamGatewayV3Server.gw_firmware.url = this.serverForm.value.gw_firmware_url;
        this.deviceParamGatewayV3Server.gw_firmware.version = this.serverForm.value.gw_firmware_version;
        this.deviceParamGatewayV3Server.liris_firmware.url = this.serverForm.value.liris_firmware_url;
        this.deviceParamGatewayV3Server.liris_firmware.version = this.serverForm.value.liris_firmware_version;
        this.deviceParamGatewayV3Server.config = this.serverForm.value.config;
        this.deviceParamGatewayV3Server.data = this.serverForm.value.data;
    }

}
